module.exports = __webpack_public_path__ + "img/科大讯飞.888ab04.888ab04d.png";